<template>

  <data-form
    :entity="formModel"
    :fields="fields"
    @change="onChange"
    @submit="onSubmit"
    :cancel="false"
    v-loading="loading"
  />

</template>

<script>
import { post, get } from 'providers/http'

export default {
  name: 'ssl-setup',
  data () {
    return {
      loading: false,
      formModel: {
        sslSetupType: 'auto',
        certificate: '',
        key: ''
      }
    }
  },
  computed: {
    fields () {
      let fields = {
        'sslSetupType': {
          type: 'radio',
          options: [
            {
              value: 'auto',
              label: 'sslSetupType.auto'
            },
            {
              value: 'manual',
              label: 'networkType.manual'
            }
          ]
        },
        'certificate': {
          disabled: this.formModel.sslSetupType === 'auto',
          type: 'textarea'
        },
        'key': {
          disabled: this.formModel.sslSetupType === 'auto',
          type: 'text'
        }
      }

      return fields
    }
  },
  methods: {
    onChange (formModel) {
      this.formModel = formModel
    },
    async onSubmit (formModel) {
      try {
        await post('api/v1/servers/ssl-setup', formModel)
        this.$emit('next')
      }
      catch (err) {
        console.error(err)
      }
    }
  },
  async beforeMount () {
    const status = await get('api/v1/servers/ssl-setup')

    this.formModel.certificate = status.certificate
    this.formModel.key = status.key

    this.loading = false
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// SSLSetup.vue?d2a9df42